/**
 * usePayrollRunDetail — React Query hook egy bérszámfejtési futtatás részleteihez
 */

import { useQuery } from '@tanstack/react-query';
import { getRun, type PayrollRunDto } from '../api/payroll-api';

export function usePayrollRunDetail(id: string | undefined) {
  return useQuery<PayrollRunDto>({
    queryKey: ['payroll', 'run', id],
    queryFn: async () => {
      const res = await getRun(id!);
      return res.data;
    },
    enabled: !!id,
    staleTime: 30_000,
  });
}
